<script>
	import { fade, slide, fly } from 'svelte/transition';
	import { env as public_env } from '$env/dynamic/public';
	import { favoritesList } from '$lib/store/favorites';
	export let item;

	function Remove() {
		$favoritesList = $favoritesList.filter((e) => {
			return e.item.id != item.id;
		});
		localStorage.setItem('favorites', JSON.stringify($favoritesList));
	}
</script>

<li
	transition:fly={{
		x: 200,
		duration: 500
	}}
	class="flex py-6 sm:py-10"
>
	<div class="flex-shrink-0">
		<img
			src={item.photos[0].image_thumbnail}
			alt="Front of men&#039;s Basic Tee in sienna."
			class="h-24 w-24 flex-none rounded-md bg-gray-100 object-cover object-center"
		/>
	</div>

	<div class="ml-4 flex flex-1 flex-col justify-between sm:ml-6">
		<div class="relative pr-9 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:pr-0">
			<div>
				<div class="flex justify-between">
					<div class="flex flex-col flex-wrap">
						<h3 class="text-[10px] text-custom-black">
							<a
								href="/{item.product.category.slug}/{item.id}"
								class="font-medium text-gray-700 dark:text-gray-50 hover:text-gray-800"
								>{item.product.name}</a
							>
						</h3>

						{#if item.color}
							<p class="mt-[10px]">Цвет: {item.color.name}</p>
						{/if}
					</div>
				</div>
			</div>

			<div class="mt-4 sm:mt-0 sm:pr-9">
				<div class="absolute top-0 right-0">
					<button
						on:click={() => {
							Remove();
						}}
						type="button"
						class="-m-2 inline-flex p-2 text-gray-400 hover:text-gray-500"
					>
						<span class="sr-only">Remove</span>
						<svg
							class="h-5 w-5 block md:hidden"
							viewBox="0 0 20 20"
							fill="currentColor"
							aria-hidden="true"
						>
							<path
								d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
							/>
						</svg>
						<span class="hidden md:block">Удалить</span>
					</button>
				</div>
			</div>
		</div>
		<div class="flex justify-between">
			<div />
			<div class="text-[10px] text-custom-black">
				{#if Number(item.sale_price) != 0}
					{Number(item.sale_price).toLocaleString('ru')} Р
				{:else}
					{Number(item.price).toLocaleString('ru')} Р
				{/if}
			</div>
		</div>
	</div>
</li>
